import React from 'react'
import IconButton from 'material-ui/IconButton'
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert'
import IconMenu from 'material-ui/IconMenu'
import Divider from 'material-ui/Divider'
import { Link } from 'react-router'



import FlatButton from 'material-ui/FlatButton'
import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card'
import Colors from 'material-ui/styles/colors'
import Moment from 'moment'

import {List, ListItem} from 'material-ui/List'

import Avatar from 'material-ui/Avatar'

import AutoComplete from 'material-ui/AutoComplete'
import DatePicker from 'material-ui/DatePicker'
import TextField from 'material-ui/TextField'
import Slider from 'material-ui/Slider'
import DropDownMenu from 'material-ui/DropDownMenu'
import Checkbox from 'material-ui/Checkbox'

import FloatingActionButton from 'material-ui/FloatingActionButton'
import ContentAdd from 'material-ui/svg-icons/content/add'


let chDone = "/manager/static/img/res/ch_green.png"
let chWip = "/manager/static/img/res/ch_black.png"
let chPending = "/manager/static/img/res/ch_gray.png"


export default (o) => {
return(
	(!o.portfolio)? <div></div>
	:<div>
		<ListItem
			key={`[portfolio]-${o.id}`}
			style={{
				height: "90px"
			  , backgroundColor: (o.lastInteracted == o.id)? "rgba(140, 222, 232, 0.3)": "#FFF"
			}}
			leftAvatar={
				<div
					style={{
						marginTop: "5px"
					}}
				>
					<i className="material-icons">store</i>
				</div>
			}
			primaryText={
				<div
					style={{
						position: "relative"
					  , fontSize: 14
					}}
				>
						<p>
							<span style={{fontWeight: 'bold'}}>landlord: </span>
							{`${o.portfolio.firstName} ${o.portfolio.lastName}`}

							<span style={{fontWeight: 'bold', marginLeft: '15px'}}>
								<div style={{backgroundColor: "rgba(173, 152, 152, 0.9)", display: "inline-block", width: "14px", height: "14px"}}>
									<img src={"/manager/static/img/siteLogo.png"} style={{height: "14px"}}/>
								</div>
								{(o.portfolio.properties)? o.portfolio.properties.length : 0}
								<img src={"/manager/static/img/res/avatar_me.png"} style={{height: "14px"}}/>
								{(o.portfolio.tenants)? o.portfolio.tenants.length : 0}
							</span>
						</p>
				</div>
			}
			className="list-hover"
			secondaryTextLines={2}
			onClick={(evt)=> {
				o.openPanel({type: 'portfolio', id: o.id})
			}}
		/>
		<Divider inset={true} />
	</div>
)
}



// WEBPACK FOOTER //
// ./src/routes/manager/portfolios/PortfolioCard.js